import { SupabaseMomentAnalyticsTotalsService } from "../../../../modules/stats/server/analytics-service";
import { useSupabaseLoader } from "../../../../server/supabase/hooks";

import type { MomentAnalyticsTotals } from "../../../../modules/stats/server/analytics-service";
import type { UseSupabaseLoaderState } from "../../../../server/supabase/hooks/types";
import type { AnalyticsMoment } from "../types";

export const useMomentAnalyticsTotals = (
  moment: Pick<AnalyticsMoment, "id" | "account_id">,
): UseSupabaseLoaderState<MomentAnalyticsTotals> => {
  const { id, account_id } = moment;

  return useSupabaseLoader(
    async ({ supabase }) => {
      const service = new SupabaseMomentAnalyticsTotalsService(supabase);

      const momentStatsResp = await service.client
        .from(service.table)
        .select("*")
        .eq("id", id)
        .eq("account_id", account_id)
        .maybeSingle();

      if (momentStatsResp.error) {
        throw new Error("Unable to load Communication stats");
      }

      if (!momentStatsResp.data) {
        return {
          account_id,
          id,
          click_count: 0,
          delivery_count: 0,
          error_count: 0,
          first_open_count: 0,
          interact_count: 0,
          total_sends: 0,
          total_clicks: 0,
          reaction_summary: {},
        };
      }

      return momentStatsResp.data;
    },
    [id, account_id],
  );
};
